class LoadingData {

    constructor(loading=false){
        this.loading=loading;
    }

}

export default LoadingData;